import { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../../common/components/ui/loading/ButtonLoading";
import { validatePuxaCapivara } from "../../../../../common/services/netrin.api";
import { getIn, useFormikContext } from "formik";

type FormPropsValidation = {
  entityId: string;
  entityName: string;
  cpf: string;
  validCPF: boolean;
  status: boolean;
  validated: boolean;
  whatsapp?: string;
};

export default function PuxaCapivaraActivate(props: FormPropsValidation) {
  const { notifySuccess, notifyError } = useToastContext();

  const { entityId, entityName } = props;

  const [bindPuxaCapivaraInProgress, setBindPuxaCapivaraInProgress] = useState(false);
  const [shouldDeactivate, setShouldDeactivate] = useState(true);
  const [buttonLabel, setButtonLabel] = useState("Validar juridicamente");

  const { setFieldValue, values } = useFormikContext();
  const jurValidation: FormPropsValidation = getIn(values, "jurValidation");

  async function handleValidatePuxaCapivara() {
    try {
      setBindPuxaCapivaraInProgress(true);
      setButtonLabel("Em análise...");
      setShouldDeactivate(true);

      const cleanedCPF = props.cpf.replace(/[.-]/g, "");
      const result = await validatePuxaCapivara(
        cleanedCPF,
        entityId, 
        entityName
      );

      if (result.ok && result.data.resultadoFinal === "Apto") {
        notifySuccess("Validação concluída!");
        setFieldValue(`jurValidation.status`, true);
        setFieldValue(`jurValidation.validated`, true);
        setShouldDeactivate(true);
      } else if (result.ok && result.data.resultadoFinal === "Inapto") {
        notifyError("O cliente não foi aprovado na análise jurídica");
        setFieldValue(`jurValidation.status`, false);
        setFieldValue(`jurValidation.validated`, true);
        setShouldDeactivate(true);
      }    
    } catch (err) {
      console.log(err);
      notifyError("Falha ao iniciar a validação jurídica");
      setButtonLabel("Validar juridicamente");
    } finally {
      setBindPuxaCapivaraInProgress(false);
    }
  }

  useEffect(() => {
    if (jurValidation.validated) {
      setButtonLabel("Validar juridicamente");
    }

    if (props.cpf.length === 0) {
      setFieldValue("jurValidation.validated", false);
    }

    if (props.validCPF && !jurValidation.validated) {
      setShouldDeactivate(false);
    }

    if (!props.validCPF) {
      setShouldDeactivate(true);
    }

    if (jurValidation.validated === true) {
      setShouldDeactivate(true);
    }

  }, [
    props.validCPF,
    jurValidation.validated,
    props.cpf,
    setFieldValue
  ]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex w-full justify-between items-center">
        <h2 className="font-semibold">
          Clique aqui para validar juridicamente o cliente:
        </h2>
      </div>

      <div className="flex w-full justify-between items-center">
        <h2 className="font-semibold">Clique aqui para validar CNH</h2>

        <div className="grid-div2">
          <ButtonWithLoader
            type="button"
            disabled={shouldDeactivate || bindPuxaCapivaraInProgress}
            isLoading={bindPuxaCapivaraInProgress}
            onClick={handleValidatePuxaCapivara}
          >
            {buttonLabel}
          </ButtonWithLoader>

          {jurValidation.validated === false ? null : jurValidation.status ? (
            <FaCheckCircle size={24} className="text-greenPrimary" />
          ) : (
            <FaTimesCircle size={24} className="text-redPrimary" />
          )}
        </div>
      </div>
    </div>
  );
}
